module.exports = __webpack_public_path__ + "static/media/21ECLAC52.4f38a7be.jpg";